<template>
  <div class="xs-font p4 container fill">
      <div class="border-bottom b8">
        <b>Run Function</b>
        {{item}}
      </div>
      <row w j="between">
        <if
          class="m4"
          :name="name + '_conditional'"
          :item="item"
          :conditions="item.if || []"
        />
        <div v-if="Object.keys(functions).length > 0">
          Choose Function
          <select
            class="r8 l8"
            @change="
              $set(item, 'payload', {});
              updatevalue(item);
            "
            v-model="item.fun"
          >
            <option :value="null">None</option>
            <option
              selected
              v-for="(fn, fnkey) in functions"
              :key="fnkey"
              :value="fnkey"
            >
              {{ fn.name }}
            </option>
          </select>
        </div>
        <span class="warn-text" v-else>No functions available</span>
        <div>
          <a
            class="update-text"
            @click="$set(show, 'createedit', !show.createedit)"
            ><i :class="`fa fa-chevron-${show.createedit ? 'up' : 'down'}`"></i>
            Edit Functions</a
          >
          <function v-if="show.createedit" />
        </div>
      </row>

    <div v-if="item.fun && $store.state.app.advanced.functions[getFunctionId(item.fun)]">
      <div
        class="flex align-center"
        v-for="(input, inputkey) in $store.state.app.advanced.functions[
          getFunctionId(item.fun)
        ].inputs"
        :key="inputkey"
      >
        <row>
          {{ inputkey }}:
          <iinput
            :value="item.payload[inputkey]"
            v-if="item.payload"
            v-model="item.payload[inputkey]"
            @change="updatevalue(item)"
          />
        </row>
        <div v-if="props" class="flex align-center wrap">
          <span
            class="m4"
            v-for="(prop, propi) in props"
            :key="propi + prop + 'hookinput'"
            @click="
              $set(item.payload, inputkey, 'prop__' + prop);
              updatevalue(item);
            "
          >
            {{ prop }}
          </span>
        </div>
      </div>
    </div>

    <code v-if="$store.state.debug">{{ item }}</code>
  </div>
</template>

<script>
export default {
  computed: {
    functions(){
      return Object.fromEntries(Object.entries(this.$store.state.app.advanced.functions).filter(x=>typeof x[1] !== 'string'))
    }
  },
  data() {
    return {
      show: {},
      input: this.value,
    };
  },
  methods: {
    updatevalue: function (value) {
      this.$set(this, "input", value);
      this.$emit("input", value);
    },
    getFunctionId(nameOrId) {
      // First try to find by name in ref.functions, then fallback to direct ID lookup
      return this.$store.state.ref.functions[nameOrId] || nameOrId;
    },
    findcurrentfunction(id){
      if (typeof this.$store.state.app.advanced.functions[id] !== 'string') {
        return id
      } else return this.findcurrentfunction(this.$store.state.app.advanced.functions[this.item.fun])
    }
  },
  props: {
    props: { type: Array },
    item: { type: Object },
    name: { type: String },
    value: {
      type: [String, Object, Number, Boolean, Array, Function],
    },
  },
  mounted () {
    // check or trace function
    if (this.item.fun && typeof this.$store.state.app.advanced.functions[this.item.fun] == 'string' ) {
      this.item.fun = this.findcurrentfunction(this.$store.state.app.advanced.functions[this.item.fun])
      this.updatevalue(this.item)
    }
  }
};
</script>

<style>
</style>